<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <section class="flex flex-col gap-6">
    <div class="flex flex-col gap-14">
      <h1 class="text-4xl font-bold md:text-5xl">Capawesome Cloud Security</h1>
      <p class="w-full text-balance text-xl leading-snug md:w-2/3">
        Move forward with confidence. Capawesome Cloud is built with security in
        mind, ensuring your live updates are delivered safely and reliably. Our
        commitment to security means you can focus on delivering exceptional
        user experiences without compromising on safety.
      </p>
      <div class="flex space-x-4">
        <a
          iconEnd="@tui.arrow-right"
          size="l"
          tuiButton
          type="button"
          [href]="'mailto:' + emailSupport"
          target="_blank"
          data-umami-event="trust-cta-contact-us-button"
        >
          Contact us
        </a>
        <a
          appearance="outline"
          size="l"
          tuiAppearanceMode="checked"
          tuiButton
          type="button"
          [href]="'mailto:' + emailSecurity"
          data-umami-event="trust-cta-report-concern-button"
        >
          Report a concern
        </a>
      </div>
    </div>
  </section>
  <section class="flex flex-col gap-12">
    @for (group of groups; track group.label; let isLast = $last) {
      <div
        class="flex flex-col gap-14"
        [class.border-b]="!isLast"
        [class.border-gray-200]="!isLast"
        [class.pb-14]="!isLast"
      >
        <h2 class="text-3xl font-bold md:text-4xl">{{ group.label }}</h2>
        @for (item of group.items; track item.label) {
          <div class="flex flex-col justify-between gap-4 md:flex-row">
            <h3 class="text-xl font-semibold md:text-2xl">{{ item.label }}</h3>
            <p class="text-balance text-lg leading-snug md:w-1/2 md:text-xl">
              {{ item.description }}
            </p>
          </div>
        }
      </div>
    }
  </section>
</div>
